import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

const OPTIONS = [
  { value: 'loan', label: 'Yrityslaina' },
  { value: 'factoring', label: 'Laskurahoitus' },
];

const pillTransition = (theme) =>
  theme.transitions.create(['flex', 'max-width', 'opacity', 'padding', 'margin', 'min-width'], {
    duration: theme.transitions.duration.standard,
    easing: theme.transitions.easing.easeInOut,
  });

export default function ProductPicker({ product, onChange, locked = false }) {
  return (
    <Box sx={{ px: 2, pt: 2, pb: 0.5 }}>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 1.25, textAlign: 'center', fontWeight: 500 }}
      >
        {locked ? 'Valittu rahoitustuote' : 'Valitse rahoitustuote'}
      </Typography>
      <Stack
        direction="row"
        spacing={locked ? 0 : 1.25}
        justifyContent={locked ? 'center' : 'stretch'}
        role="group"
        aria-label="Rahoitustuote"
        sx={{
          transition: (theme) =>
            theme.transitions.create(['gap'], {
              duration: theme.transitions.duration.standard,
            }),
        }}
      >
        {OPTIONS.map(({ value, label }) => {
          const selected = product === value;
          const hidden = locked && !selected;

          return (
            <Button
              key={value}
              fullWidth={!locked}
              disableElevation
              variant={selected ? 'contained' : 'outlined'}
              color="primary"
              onClick={hidden ? undefined : () => onChange(value)}
              aria-pressed={selected}
              aria-label={label}
              aria-hidden={hidden}
              tabIndex={hidden ? -1 : 0}
              sx={{
                borderRadius: 999,
                minHeight: 48,
                px: hidden ? 0 : 2,
                fontWeight: 600,
                fontSize: '0.875rem',
                textTransform: 'none',
                borderWidth: 2,
                flex: hidden ? '0 0 0px' : 1,
                maxWidth: hidden ? 0 : locked ? 280 : 'none',
                minWidth: hidden ? 0 : undefined,
                opacity: hidden ? 0 : 1,
                overflow: 'hidden',
                pointerEvents: hidden || locked ? 'none' : 'auto',
                transition: pillTransition,
                ...(selected
                  ? {
                      boxShadow: (theme) =>
                        theme.palette.mode === 'dark'
                          ? '0 2px 8px rgba(0,0,0,0.35)'
                          : '0 2px 8px rgba(18, 38, 82, 0.12)',
                    }
                  : {
                      bgcolor: 'background.paper',
                      borderColor: 'divider',
                      color: 'text.primary',
                      '&:hover': {
                        bgcolor: 'mobile.highlight',
                        borderColor: 'primary.main',
                        borderWidth: 2,
                      },
                    }),
              }}
            >
              {label}
            </Button>
          );
        })}
      </Stack>
    </Box>
  );
}
